import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import * as React from 'react';
import { StyledActionSheetButton, StyledActionSheetItem, StyledActionSheetItemTitle } from './MobileActionSheetItem.styled';
export var MobileActionSheetItem = /*#__PURE__*/function (_React$Component) {
  function MobileActionSheetItem() {
    _classCallCheck(this, MobileActionSheetItem);
    return _callSuper(this, MobileActionSheetItem, arguments);
  }
  _inherits(MobileActionSheetItem, _React$Component);
  return _createClass(MobileActionSheetItem, [{
    key: "render",
    value: function render() {
      var _this = this;
      return /*#__PURE__*/React.createElement(StyledActionSheetButton, {
        onClick: function onClick() {
          return _this.onClick();
        }
      }, /*#__PURE__*/React.createElement(StyledActionSheetItem, null, /*#__PURE__*/React.createElement(StyledActionSheetItemTitle, null, this.props.title)));
    }
  }, {
    key: "onClick",
    value: function onClick() {
      this.props.onClick();
      this.props.closeMenu();
    }
  }]);
}(React.Component);